import { render } from "./TablaServiciosColectivosSolicitados.vue?vue&type=template&id=4e9f1766&ts=true"
import script from "./TablaServiciosColectivosSolicitados.vue?vue&type=script&lang=ts"
export * from "./TablaServiciosColectivosSolicitados.vue?vue&type=script&lang=ts"

import "./TablaServiciosColectivosSolicitados.vue?vue&type=style&index=0&id=4e9f1766&lang=css"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__